import React from 'react';

import PropTypes from 'prop-types';

import Chart from './components/chart';
import SectionBox from './components/section';
import Selector from './components/selector';
import { useTranslationData } from './hooks';
import { getTotalCount } from './utils';

/**
 * @typedef { import('../../basic/types').Props } Props
 * @typedef { import('../../basic/types').ChildrenProps } ChildrenProps
 */

/** @type { React.FC<ChildrenProps> } */
const CurrencyOverviewContent = (props) => {
	const { query } = props;

	const [type, setType] = React.useState(null);

	const onChangeType = React.useCallback((next) => {
		setType((prev) => {
			if (prev === next) {
				return null;
			}

			return next;
		});
	}, []);

	const data = Array.from(query.data?.source ?? []).sort(
		(a, b) => getTotalCount(b) - getTotalCount(a),
	);

	const translationData = useTranslationData(data, type);

	return (
		<div className="flex flex-col gap-4">
			<Selector
				{...props}
				data={data}
				type={type}
				onChangeType={onChangeType}
			/>
			<Chart
				{...props}
				data={data}
				type={type}
				translationData={translationData}
			/>
			<div className="grid grid-cols-2 gap-4">
				<SectionBox
					{...props}
					section="exposure"
					type={type}
					translationData={translationData}
				/>
				<SectionBox
					{...props}
					section="risk"
					type={type}
					translationData={translationData}
				/>
				<SectionBox
					{...props}
					section="account"
					type={type}
					translationData={translationData}
				/>
				<SectionBox
					{...props}
					section="total"
					type={type}
					translationData={translationData}
				/>
			</div>
		</div>
	);
};

CurrencyOverviewContent.propTypes = {
	query: PropTypes.object,
	translationOptions: PropTypes.shape({
		postfix: PropTypes.object,
		data: PropTypes.object,
	}),
	onAction: PropTypes.func,
	onSubmit: PropTypes.func,
};

export default CurrencyOverviewContent;
